import { useState } from 'react';
import { useConnect } from '@lore/query-connect';
import { useUser } from '@lore/auth';
import getBucketParams from '../my-events/getBucketParams';

const timestamp = new Date().toISOString();

export default function usePastEvents(props) {
  const currentUser = useUser();
  // const [timestamp] = useState(new Date().toISOString());

  const params = getBucketParams(timestamp);

  return useConnect('event.find', {
    where: {
      eager: {
        $where: {
          creatorId: currentUser.id,
          activityId: {
            $null: false
          },
          ...params.past
        }
      }
    },
    pagination: {
      pageSize: 100,
      order: 'createdAt desc'
    }
  });
}
